module.exports = __webpack_public_path__ + "media/images/providers/universe-21b9ed84d94f04b0c4f1837d403febb0.png";